import React, { useEffect, useState } from 'react';
import { useLocation, Routes, Route, Navigate } from 'react-router-dom';

import './CategoryManagement.css';
import CreateCategories from './CreateCategories/CreateCategories';
import ListCategories from './ListCategories/ListCategories';

import Notification from '../Notification/Notification';

function CategoryManagement() {
  const location = useLocation();
  const [notification, setNotification] = useState({ message: '', type: '' });

  useEffect(() => {
    if (location.state && location.state.message) {
      setNotification({
        message: location.state.message,
        type: location.state.type,
      });
      window.history.replaceState({}, document.title);
    }
  }, [location]);

  return (
    <div>
      <h1>Category Management</h1>
      <Routes>
        <Route path="/" element={<Navigate to="list" />} />
        <Route path="list" element={<ListCategories />} />
        <Route path="create" element={<CreateCategories />} />

      </Routes>
      <Notification
        message={notification.message}
        type={notification.type}
        onClose={() => setNotification({ message: '', type: '' })}
      />

    </div>
  );
}

export default CategoryManagement;
